import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Seguidor } from '../services/seguidorService';
import Load from './Load';

interface TournamentSeguidoresTabProps {
  seguidores: Seguidor[];
  loading: boolean;
  error: string | null;
}

const TournamentSeguidoresTab: React.FC<TournamentSeguidoresTabProps> = ({
  seguidores,
  loading,
  error,
}) => {
  const navigate = useNavigate();

  if (loading) {
    return <Load />;
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        {error}
      </div>
    );
  }

  if (seguidores.length === 0) {
    return (
      <div>
        <h5 className="fw-600 text-grey-900 mb-3">Seguidores do Torneio</h5>
        <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3">
          <div className="card-body text-center">
            <p className="mb-0">Nenhum seguidor encontrado.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <h5 className="fw-600 text-grey-900 mb-3">Seguidores do Torneio</h5>
      <div className="row g-3">
        {seguidores.map((seguidor) => {
          const atleta = seguidor.seguidor;
          return (
            <div key={seguidor.id} className="col-12 col-sm-6 col-lg-4">
              <div
                className="card w-100 shadow-xss rounded-xxl border-0 p-3 hover-card"
                style={{ cursor: 'pointer' }}
                role="button"
                tabIndex={0}
                onClick={() => navigate(`/userpage/${atleta?.id}`)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    navigate(`/userpage/${atleta?.id}`);
                  }
                }}
              >
                <div className="d-flex align-items-center">
                  <figure className="avatar me-3 mb-0">
                    <img
                      src={atleta?.usuario?.imagemUrl || '/assets/images/avatar.jpg'}
                      alt={atleta?.usuario?.nome || 'Avatar'}
                      className="rounded-circle w-100"
                      style={{ width: 48, height: 48, objectFit: 'cover' }}
                    />
                  </figure>
                  <div className="flex-grow-1 min-w-0">
                    <div className="fw-600 text-grey-900 text-truncate">
                      {atleta?.usuario?.nome || '\u2014'}
                    </div>
                    {atleta?.usuario?.username && (
                      <div className="font-xssss text-primary text-truncate">
                        @{atleta.usuario.username}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TournamentSeguidoresTab;
